import { fetchGeoInfoApi } from 'support/api/GeoApi';
import { HttpClient } from 'support/api/api-types';

export const GEO_INFO = 'GEO_INFO' as const;

export const fetchGeoInfo = () => {
  return {
    type: GEO_INFO,
    promise: (httpClient: HttpClient) => fetchGeoInfoApi(httpClient),
  };
};
